/**
 * What this browser can actually do, decided before the guest is offered anything.
 *
 * Safari in an iOS tab is the case worth naming: it has no PushManager and cannot get one, so
 * the honest answer is a sentence telling the guest how to reach a browser that can, not a
 * button that throws when pressed. The same device added to the home screen is a different
 * runtime and is treated as such.
 */

export const SUPPORTED = 'supported';
export const UNSUPPORTED = 'unsupported';
export const UNSUPPORTED_IOS_TAB = 'unsupported-ios-tab';

function isIosDevice(navigatorRef) {
  const ua = (navigatorRef && navigatorRef.userAgent) || '';
  if (/iPad|iPhone|iPod/.test(ua)) {
    return true;
  }
  // iPadOS 13 and later report a desktop Macintosh user agent. The touch points are what give
  // it away, and a real Mac reports zero.
  return /Macintosh/.test(ua) && Number(navigatorRef && navigatorRef.maxTouchPoints) > 1;
}

function isStandalone(navigatorRef, windowRef) {
  if (navigatorRef && navigatorRef.standalone === true) {
    return true;
  }
  if (!windowRef || typeof windowRef.matchMedia !== 'function') {
    return false;
  }
  try {
    return windowRef.matchMedia('(display-mode: standalone)').matches === true;
  } catch (error) {
    return false;
  }
}

export function detectVisitorPushSupport(scope = {}) {
  const windowRef = scope.windowRef || (typeof window !== 'undefined' ? window : null);
  const navigatorRef = scope.navigatorRef
    || (windowRef && windowRef.navigator)
    || (typeof navigator !== 'undefined' ? navigator : null);

  if (!navigatorRef || !windowRef) {
    return UNSUPPORTED;
  }

  if (isIosDevice(navigatorRef) && !isStandalone(navigatorRef, windowRef)) {
    return UNSUPPORTED_IOS_TAB;
  }

  if (!navigatorRef.serviceWorker) {
    return UNSUPPORTED;
  }
  if (typeof windowRef.PushManager === 'undefined') {
    return UNSUPPORTED;
  }
  if (typeof windowRef.Notification === 'undefined') {
    return UNSUPPORTED;
  }

  return SUPPORTED;
}
